<div class="boxWhite">
    <h4>EDITAR JORNADA</h4>

    <button class="btn btnClose" (click)="close()">
        <img src="assets/img/icoClose.svg" alt="">
    </button>

    <div class="contModal">
        <div class="row">
            <div class="col-sm-6">
                <h6 class="clBlack">ID CB</h6>
                <p class="clGray mb-4">{{jornada?.conductor.visibleId}}</p>
            </div>
            <div class="col-sm-6">
                <h6 class="clBlack">nombre conductor</h6>
                <p class="clGray mb-4">{{jornada?.conductor.nombres}} {{jornada?.conductor.apellidoPaterno}}</p>
            </div>
        </div>

        <div class="row" [formGroup]="formHoras">
            <div class="col-sm-6">
                <div class="mb-4">
                    <h6 class="clBlack">Hora Inicio J.</h6>
                    <input type="time" class="form-control" placeholder="HORA INICIO" formControlName="horaInicio" (change)="verificaHorasDiaSiguiente($event)">
                    <!--HORA INICIO
                    <timepicker formControlName="horaInicio" [showMeridian]="false"></timepicker>-->
                </div>
            </div>
            <div class="col-sm-6">
                <div class="mb-4">
                    <h6 class="clBlack">Hora Término J.</h6>
                    <!--<input type="time" class="form-control" placeholder="HORA TÉRMINO" formControlName="horaTermino" (change)="verificaHorasDiaSiguiente($event)">-->
                    <input type="time" class="form-control" placeholder="HORA TÉRMINO" formControlName="horaTermino" (change)="verificaHorasDiaSiguiente($event)">
                    <span class="textoRojo" *ngIf="banderaDiaSiguiente"><small>Siguiente Día</small></span>
                  <!--HORA TÉRMINO
                  <timepicker formControlName="horaTermino" [showMeridian]="false"></timepicker>-->
                </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-4">
                <h6 class="clBlack">Día de Inicio J.</h6>
                <input type="text" class="form-control" [value]="diaInicioFormateado" disabled>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-4">
                <h6 class="clBlack">Día de Término J.</h6>
                <input type="text" class="form-control" placeholder="DÍA TÉRMINO" bsDatepicker [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                       formControlName="diaTermino">
              </div>
          </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="boxInsideModal bgLightGray mb-2 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>Estado Jornada</h6>
                        <p class="clLightBlue m-0 fw-medium">{{estadosService.transformGestionJornadaEstado(jornada?.estado)}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
              <div class="d-flex flex-column justify-content-center">
                <h6>Estado Conductor</h6>
                <p class="clLightBlue m-0 fw-medium">{{jornada?.conductor.estado.replace('_', ' ')}}</p>
              </div>
            </div>
          </div>
        </div>

    </div>


    <div class="footModal">
        <button *ngIf="tienePermisoEditarJornada()" class="btn btnBlack w-100" [disabled]="enviando" (click)="putActualizarHoraJornada()">
            <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            CONFIRMAR EDICIÓN
        </button>
    </div>


</div>
